import { render } from "./my-training.vue?vue&type=template&id=4a1fd690&scoped=true"
import script from "./my-training.vue?vue&type=script&lang=js"
export * from "./my-training.vue?vue&type=script&lang=js"

import "./my-training.vue?vue&type=style&index=0&id=4a1fd690&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1fd690"]])

export default __exports__